module.exports = __webpack_public_path__ + "img/Unauthorized.01e6f4b9.png";